module.exports = __webpack_public_path__ + "img/7123025_logo_google_g_icon.45aebcf8.svg";